import {Alert, Col, Row} from 'antd';
import {FC} from 'react';
import {Link} from 'react-router-dom';

const MAINTENANCE_MODE = false;

const Banner: FC = () => (
  <Row
    justify="center"
    style={{
      maxWidth: '100%',
      width: '1200px',
      textAlign: 'center',
      margin: 'auto',
      position: 'relative',
      top: '-18px',
    }}
  >
    <Col
      span={24}
      lg={12}
      style={{
        marginBottom: '5px',
        color: '#28314e',
        borderBottom: '1px solid #28314e',
      }}
    >
      <img
        src="/assets/2022/questions.svg"
        alt="Logo question"
        style={{maxHeight: '50px'}}
      />
      <span style={{textTransform: 'uppercase'}}>Des questions ?&nbsp;</span>
      <Link
        to="/contact"
        style={{fontWeight: 'bold', textDecoration: 'underline'}}
      >
        Contactez-nous
      </Link>
    </Col>
    <Col
      span={24}
      lg={12}
      style={{
        marginBottom: '5px',
        color: '#28314e',
        borderBottom: '1px solid #28314e',
      }}
    >
      <img
        src="/assets/2022/horloge.svg"
        alt="Logo horaires"
        style={{maxHeight: '50px'}}
      />
      <span style={{textTransform: 'uppercase'}}>Ouvert toute l'année</span>
      {/*&nbsp; <b>9h à 12h30 | 13h30 à 17h30</b> */}
    </Col>

    {MAINTENANCE_MODE ? (
      <Alert
        type="error"
        message="En cours de maintenance, merci de réessayer plus tard"
      />
    ) : undefined}
  </Row>
);

export default Banner;
